export const ExpressionOfInterestFeatureNames = {
  ReviewsOnlySubscription: 'ReviewsOnlySubscription',
} as const;

export type ExpressionOfInterestFeatureName = keyof typeof ExpressionOfInterestFeatureNames;

export interface ExpressionOfInterestRequest {
  featureName: ExpressionOfInterestFeatureName;
  additionalDetails?: string;
  isHandled?: boolean;
}
